import { render, staticRenderFns } from "./EditOrigin.vue?vue&type=template&id=25db7398&scoped=true"
import script from "./EditOrigin.vue?vue&type=script&lang=js"
export * from "./EditOrigin.vue?vue&type=script&lang=js"
import style0 from "./EditOrigin.vue?vue&type=style&index=0&id=25db7398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25db7398",
  null
  
)

export default component.exports